export default __webpack_public_path__ + "static/media/careerstopbanner.f417f0e6.webp";